<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="pedidos"
            :loading="loading"
            :page.sync="page"
            :expanded.sync="expanded"
            :items-per-page="itemsPerPage"
            item-key="codigoVenta"
            single-expand
            hide-default-footer
            class="elevation-1"
            show-expand
        >
            <template v-slot:item.fecha="{ item }">
                {{ item.fecha | dateFormat }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td
                    v-if="item.detallesVenta && item.detallesVenta.length"
                    :colspan="headers.length"
                >
                    <ul
                        class="list"
                        v-for="(detalle, index) in item.detallesVenta"
                        :key="index"
                    >
                        <v-container fluid grid-list-xl>
                            <v-layout justify-space-around>
                                <v-flex>
                                    <v-card dark color="azul" width="400px">
                                        <v-card-text>
                                            {{ detalle.nombre }}
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs3>
                                    <v-card dark color="azul">
                                        <v-card-text>Cantidad</v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs2>
                                    <v-card
                                        dark
                                        color="azul"
                                        min-width="40px"
                                        width="60px"
                                        class="text-center"
                                    >
                                        <v-card-text>
                                            {{ Math.round(detalle.cantidad) }}
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </ul>
                </td>
            </template>
            <template v-slot:item.actions="{ item }">
                <td class="text-center px-0">
                    <v-btn icon @click="repetirPedido(item)" small>
                        <v-icon>cart</v-icon>
                        Repetir Pedido
                    </v-btn>
                </td>
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" />
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import format from './../utils/dateFormat';

export default {
    data: () => ({
        page: 1,
        expanded: [],
        itemsPerPage: 12,
        headers: [
            { text: 'Código', value: 'codigoVenta', sortable: false },
            { text: 'Fecha', value: 'fecha', sortable: true },
            { text: 'Estado', value: 'estado', sortable: false },
            { text: 'Acciones', value: 'actions', sortable: false }
        ]
    }),

    filters: {
        dateFormat(value) {
            if (!value) return '';
            return format(value, 'dd/MM/yyyy HH:mm');
        }
    },

    computed: {
        ...mapState('pedidos', ['loading', 'pedidos', 'pageCount'])
    },

    methods: {
        ...mapActions('pedidos', ['getPedidos']),
        ...mapMutations('products', ['CLEAR_CART', 'ADDTOCART']),

        updateProducts() {
            this.getPedidos({
                page: this.page,
                itemsPerPage: this.itemsPerPage
            });
        },

        repetirPedido({ detallesVenta }) {
            this.CLEAR_CART();
            let pedidoAlterado = false;
            detallesVenta.forEach(dv => {
                if (dv.producto) {
                    this.ADDTOCART({
                        product: dv.producto,
                        cantidad: dv.cantidad
                    });
                } else {
                    pedidoAlterado = true;
                }
            });
            if (pedidoAlterado) {
                alert(
                    'El pedido elegido tiene productos editados o eliminados del sistema.'
                );
            }
            this.$router.push({ name: 'Carrito' });
        }
    },

    watch: {
        page() {
            this.updateProducts();
        }
    },

    mounted() {
        this.updateProducts();
    }
};
</script>
<style>
.list {
    position: relative;
    width: 600px;
    margin: 5px auto 0;
    padding: 5px;
    box-sizing: border-box;
}
</style>
